import PropTypes from 'prop-types'
import NavBarMenu from './NavBarMenu/Index'
import NavBarMenuItem from './NavBarMenu/NavBarMenuItem'

import { RouteReleaseNotesAny, RouteReleaseNotes, RouteApiDoc } from 'routes'

import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'

const NavAbout = ({ canAccessApiDoc }) => {
  const location = useLocation()
  const { t } = useTranslation()

  const matchReleasesPath = RouteReleaseNotesAny.matchUrlExact(location.pathname)
  const matchApiDocPath = RouteApiDoc.matchUrlExact(location.pathname)
  const activeNavTab = !!(matchReleasesPath || matchApiDocPath)

  return (
    <NavBarMenu active={activeNavTab} title={t('mainHeader.about')}>
      <NavBarMenuItem name={t('mainHeader.aboutReleaseNotes')} to={RouteReleaseNotes()} />
      {canAccessApiDoc &&
        <NavBarMenuItem name={t('mainHeader.aboutApiDocumentation')} to={RouteApiDoc()} />
      }
    </NavBarMenu>
  )
}

NavAbout.propTypes = {
  canAccessApiDoc: PropTypes.bool,
}

export default NavAbout
